import _ from 'lodash';
import PropTypes from 'prop-types';
import { SVG_PROP_TYPE } from '@eb/eds-vector-image';
import { SIZES_JSON } from '@eb/eds-iconography';

export const GRAPHIC_SIZES = _.chain(SIZES_JSON)
    .keys()
    .filter((size) => size.indexOf('graphic-') >= 0)
    .map((size) => size.replace('graphic-', '').replace('halo-', ''))
    .uniq()
    .value();

// PropTypes
export const GRAPHIC_TYPE_PROP_TYPE = SVG_PROP_TYPE;
export const GRAPHIC_SIZE_PROP_TYPE = PropTypes.oneOf(GRAPHIC_SIZES);
